import randomId from 'javascripts/utils/random-id';
import Slider from '../../../javascripts/globals/slider';
import { Pagination } from '../../../javascripts/globals/slider-extensions';

export default class TeasersSlider {
  constructor($el, options) {
    this.$el = $el;
    this.id = options.id || `teasers-slider${randomId()}`;

    const localOptions = {
      id: this.id,
      ...options,
    };

    this.initSlider(localOptions);
    this.initPagination(localOptions);

    if (options.resizeObserver) {
      $el.teaserSlider = {
        pagination: this.pagination,
      };
      options.resizeObserver.observe($el);
    }
  }

  initSlider(options) {
    this.slider = new Slider(this.$el, options);
  }

  initPagination(options) {
    this.pagination = new Pagination(this.$el, this.slider, options);
  }

  static onResize(entries) {
    entries.forEach((entry) => {
      const { teaserSlider } = entry.target;
      if (teaserSlider === undefined) return;

      const { pagination } = teaserSlider;
      if (pagination === undefined) return;

      pagination.updateTotal();
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const resizeObserver = new ResizeObserver(TeasersSlider.onResize);
  document.querySelectorAll('.js-teasers-slider').forEach(
    $teasersSlider => new TeasersSlider($teasersSlider, {
      sliderFrame: 'teasers-slider__items',
      sliderItem: 'teasers-slider__item',
      pagination: 'teasers-slider__pagination',
      resizeObserver,
    }),
  );
});
